import { useState, createContext, useMemo, useCallback } from "react";
import { EstablishmentInfosType } from "../../../types/ClientSpace";

type EstablishmentInfosContextType = EstablishmentInfosType & {
    updateEstablishementInfos: Function;
};

export const EstablishementInfosContext =
    createContext<EstablishmentInfosContextType>({
        id: null,
        name: "",
        email: "",
        phoneNumber: "",
        establishment: {
            id: null,
            siret: "",
            establishmentType: {
                id: null,
                name: "",
                code: "",
            },
            establishmentGroup: {
                id: null,
                name: "",
                code: "",
            },
            region: {
                id: null,
                name: "",
                code: "",
            },
            // synerpaNum: "",
            companyName: "",
            contactAddress: {
                id: null,
                postalCode: "",
                city: "",
                street: "",
                additionalDetails: "",
            },
            billingAddress: {
                id: null,
                postalCode: "",
                city: "",
                street: "",
                additionalDetails: "",
            },
        },
        updateEstablishementInfos: (signupForm: any) => null,
    });

export const EstablishementInfosContextProvider = ({ children }: any) => {
    const [establishementInfos, setEstablishementInfos] =
        useState<EstablishmentInfosType>({
            id: null,
            name: "",
            email: "",
            phoneNumber: "",
            establishment: {
                id: null,
                siret: "",
                region: {
                    id: null,
                    name: "",
                    code: "",
                },
                establishmentType: {
                    id: null,
                    name: "",
                    code: "",
                },
                establishmentGroup: {
                    id: null,
                    name: "",
                    code: "",
                },
                // synerpaNum: "",
                companyName: "",
                contactAddress: {
                    id: null,
                    postalCode: "",
                    city: "",
                    street: "",
                    additionalDetails: "",
                },
                billingAddress: {
                    id: null,
                    postalCode: "",
                    city: "",
                    street: "",
                    additionalDetails: "",
                },
            },
        });

    const updateEstablishementInfos = useCallback(
        (establishementInfos: EstablishmentInfosType) => {
            setEstablishementInfos(establishementInfos);
        },
        []
    );

    const EstablishementInfosWrapperContext = useMemo(
        () => ({
            ...establishementInfos,
            updateEstablishementInfos,
        }),
        [establishementInfos, updateEstablishementInfos]
    );

    return (
        <EstablishementInfosContext.Provider
            value={EstablishementInfosWrapperContext}
        >
            {children}
        </EstablishementInfosContext.Provider>
    );
};
